import { Franchise } from '@/types';
import { Button, Flex, Form, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router';
import { LeftOutlined } from '@ant-design/icons';
import { FranchiseCreate } from '@/components/admin/create/FranchiseCreate';

const CreateDetailsPageFranchisor = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<Partial<Franchise>>();

  const onBack = () => {
    navigate(`/control-panel/franchisors`);
  };

  const onCancel = () => {
    navigate(`/control-panel/franchisors`);
  };

  return (
    <>
      <Flex justify="start" align="start" gap={8} vertical>
        <Button
          type="link"
          icon={<LeftOutlined />}
          onClick={onBack}
          style={{ color: '#22252D', fontWeight: 500, paddingLeft: 0 }}
        >
          Back
        </Button>
        <Typography.Title
          level={3}
          style={{
            margin: '0 0 24px',
          }}
        >
          Create Franchise
        </Typography.Title>
      </Flex>
      <FranchiseCreate form={form} onCancel={onCancel} />
    </>
  );
};

export default CreateDetailsPageFranchisor;
